import { Navigate, Route, Routes } from 'react-router-dom';
import { OdmLayout } from 'layout/Layout';
import ContactPage from './static/ContactPage';
import InprintPage from './static/ImprintPage';
import DataProtectionPage from './static/DataProtectionPage';
import TermsOfUsePage from './static/TermsOfUsePage';
import HelpPage from './static/HelpPage';
import LoginPage from './auth/LoginPage';
import { ResetPasswordPage } from './auth/ResetPasswordPage';
import { ResetPasswordSuccessPage } from './auth/ResetPasswordSuccessPage';
import { RouteKey } from './AppRoutes';
import { ManagedOnlinedienstePage } from './ManagedOnlinedienstePage';
import { ManagedOnlinedienstDetailPage } from './ManagedOnlinedienstDetailPage';
import { ZustaendigeStellePage } from './ZustaendigeStellePage';
import { MarketplaceOnlinedienstPage } from './MarketplaceOnlinedienstPage';
import { TemplateConfigurationPage } from './TemplateConfigurationPage';
import { RouteGuardGuest } from './RouteGuardGuest';

export function AppRouter() {
  return (
    <Routes>
      <Route element={<OdmLayout />}>
        <Route
          path={RouteKey.HOME}
          element={<Navigate to={RouteKey.MANAGED_ONLINEDIENSTE} />}
        />
        <Route element={<RouteGuardGuest />}>
          <Route path={RouteKey.LOGIN} element={<LoginPage />} />
        </Route>
        <Route path={RouteKey.RESET_PASSWORD} element={<ResetPasswordPage />} />
        <Route
          path={RouteKey.RESET_PASSWORD_SUCCESS}
          element={<ResetPasswordSuccessPage />}
        />

        {/* Static pages */}
        <Route path={RouteKey.CONTACT} element={<ContactPage />} />
        <Route path={RouteKey.IMPRINT} element={<InprintPage />} />
        <Route
          path={RouteKey.DATA_PROTECTION}
          element={<DataProtectionPage />}
        />
        <Route path={RouteKey.TERMS_OF_USE} element={<TermsOfUsePage />} />
        <Route path={RouteKey.HELP} element={<HelpPage />} />
        <Route
          path={RouteKey.NOT_FOUND}
          element={<Navigate to={RouteKey.LOGIN} />}
        />
      </Route>
      <Route element={<OdmLayout isRouteGuardAuthorized />}>
        <Route
          path={RouteKey.MANAGED_ONLINEDIENSTE}
          element={<ManagedOnlinedienstePage />}
        />
        <Route
          path={RouteKey.MANAGED_ONLINEDIENST}
          element={<ManagedOnlinedienstDetailPage />}
        />
        <Route
          path={RouteKey.MARKETPLACE_ONLINEDIENSTE}
          element={<MarketplaceOnlinedienstPage />}
        />
        <Route
          path={RouteKey.ZUSTAENDIGE_STELLEN}
          element={<ZustaendigeStellePage />}
        />
        <Route
          path={RouteKey.TEMPLATE_CONFIGURATION}
          element={<TemplateConfigurationPage />}
        />
      </Route>
    </Routes>
  );
}
